import {
  timeline_default
} from "./chunk-MWWKBSGI.js";

// src/layouts/timeline/index.ts
var timeline_default2 = timeline_default;

export {
  timeline_default2 as timeline_default
};
